import { DocRequestTemplateCategoryType } from './DocRequestTemplate';

// eslint-disable-next-line import/prefer-default-export
export enum DocRequestStatus {
  'pending' = 'PENDIENTE',
  'inReview' = 'PENDIENTE_REVISION',
  'returned' = 'DEVUELTO',
  'approved' = 'VALIDADO',
}

export type DocRequestGrouped = {
  [DocRequestTemplateCategoryType.physical]?: DocRequestEntity[]
  [DocRequestTemplateCategoryType.fiscal]?: DocRequestEntity[]
  [DocRequestTemplateCategoryType.investments]?: DocRequestEntity[]
  [DocRequestTemplateCategoryType.titular]?: DocRequestEntity[]
};

export type DocRequestEntity = {
  id: number
  nombre: string
  descripcion?: string
  fechaUltimaRevision?: string
  fechaLimite?: string
  fechaExpiracion?: string
  estado?: string
  contactoName?: string
  contactoID?: number
  categoria?: string
  cuentaDeInversionID: number,
  activo?: boolean,
  nombreArchivo?: string,
  urlArchivo?: string,
  tipoArchivo?: string,
  cuentaDeInversionName?: string,
  logs?: DocRequestEntityLog[]
};

export type DocRequestEntityLog = DocRequestEntity & {
  accion: 'CREADA' | 'EDITADA' | 'ARCHIVO_EDITADO' | 'ELIMINADA'
  autorAccionName: string
  fechaAccion: string
  nota: string
};

export type DocRequestForm = {
  nombre: string
  descripcion?: string
  fechaLimite?: string
  fechaExpiracion?: string
  contactoID?: string
};

export type DocRequestFilters = {
  categoria?: string | string[] | null
  estado?: string | string[] | null
  cuentaDeInversionID?: number[] | number | null
  nombre?: string
  descripcion?: string
  id?: string
  cuentaDeInversionName?: string
  fechaLimiteQuickRange?: string | null
  fechaExpiracionQuickRange?: string | null
};

export type UploadDocForm = {
  nota?: string
  file: File[]
};

export type DocNoteForm = {
  nota?: string
};

export type DocNotePayload = DocRequestEntity & { newValue?: string, field: string };
